var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.number)?_c('strong',{staticClass:"mr-1"},[_vm._v(" "+_vm._s(_vm.numberWithCommas(_vm.number))+" "+_vm._s(_vm.unit)+" ")]):_c('strong',[_vm._v("0")])])
}
var staticRenderFns = []

export { render, staticRenderFns }